var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pdf_download",
    "data-name": "Pdf download",
    transform: "translate(-1003 -576)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4882",
    "data-name": "Rectangle 4882",
    width: 20,
    height: 20,
    transform: "translate(1003 576)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pdf-svgrepo-com_2_",
    "data-name": "pdf-svgrepo-com (2)",
    transform: "translate(999.416 576.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34161",
    "data-name": "Path 34161",
    d: "M20.494,3.837l-.243-.243L17.073.416,16.83.173A.6.6,0,0,0,16.412,0H7.275A.816.816,0,0,0,6.5.921V17.63a.721.721,0,0,0,.579.6c.016,0,.031.01.047.013a.767.767,0,0,0,.15.015H19.891a.767.767,0,0,0,.15-.015c.016,0,.031-.009.047-.013a.721.721,0,0,0,.579-.6V4.4A.725.725,0,0,0,20.494,3.837Zm-.949-.059H16.889V1.122ZM7.275,17.63a.181.181,0,0,1-.062-.015.144.144,0,0,1-.083-.13V12.907H20.037v4.576a.145.145,0,0,1-.083.13.181.181,0,0,1-.062.015ZM7.13,12.278V.921c0-.068.01-.292.146-.292h9a.485.485,0,0,0-.018.123V4.407h3.655a.482.482,0,0,0,.123-.018s0,.007,0,.011v7.877Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34162",
    "data-name": "Path 34162",
    d: "M18.413,44.182a1.082,1.082,0,0,0-.355-.194,1.28,1.28,0,0,0-.4-.065h-.912V47.1h.517V45.951h.383a1.358,1.358,0,0,0,.456-.073,1.028,1.028,0,0,0,.353-.207.917.917,0,0,0,.228-.329,1.125,1.125,0,0,0,.082-.437.866.866,0,0,0-.1-.411A1.012,1.012,0,0,0,18.413,44.182Zm-.2,1.048a.519.519,0,0,1-.125.2.472.472,0,0,1-.17.105.569.569,0,0,1-.187.032h-.473V44.316h.387a.7.7,0,0,1,.319.062.522.522,0,0,1,.187.155.515.515,0,0,1,.088.194.881.881,0,0,1,.021.178A.969.969,0,0,1,18.217,45.23Z",
    transform: "translate(-7.02 -30.096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34163",
    "data-name": "Path 34163",
    d: "M27.247,44.389a1.458,1.458,0,0,0-.5-.338,1.818,1.818,0,0,0-.7-.127h-.955V47.1h1.2a1.714,1.714,0,0,0,.185-.015,1.271,1.271,0,0,0,.275-.069,1.443,1.443,0,0,0,.312-.161,1.1,1.1,0,0,0,.291-.295,1.664,1.664,0,0,0,.213-.465,2.33,2.33,0,0,0,.084-.669,1.593,1.593,0,0,0-.1-.553A1.4,1.4,0,0,0,27.247,44.389Zm-.377,1.993a.855.855,0,0,1-.757.336H25.6v-2.4h.3a1.585,1.585,0,0,1,.6.1.965.965,0,0,1,.368.254.838.838,0,0,1,.183.351,1.648,1.648,0,0,1,.047.392A1.7,1.7,0,0,1,26.87,46.381Z",
    transform: "translate(-12.733 -30.096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34164",
    "data-name": "Path 34164",
    d: "M35.6,47.1h.525V45.667h1.326v-.353H36.123v-1h1.459v-.392H35.6Z",
    transform: "translate(-19.938 -30.096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34165",
    "data-name": "Path 34165",
    d: "M24.718,12.646a6.094,6.094,0,0,0-1.057.113,10.06,10.06,0,0,1-1.6-2.381c.421-1.772.21-2.023.117-2.141s-.238-.33-.4-.33a1.553,1.553,0,0,0-.32.054.6.6,0,0,0-.357.383,3.109,3.109,0,0,0,.4,2.091,21.132,21.132,0,0,1-1.193,3.384c-1.193.547-1.827,1.083-1.884,1.6a.754.754,0,0,0,.351.706.505.505,0,0,0,.3.1h0c.275,0,.554-.211.876-.663a8.932,8.932,0,0,0,.75-1.338,15.084,15.084,0,0,1,2.779-.888,2.094,2.094,0,0,0,1.326.719.836.836,0,0,0,.7-.375.637.637,0,0,0,.123-.68C25.509,12.761,25.211,12.646,24.718,12.646Zm-5.633,3.045c-.147-.113-.139-.189-.136-.218.02-.175.294-.486.966-.864C19.406,15.551,19.132,15.676,19.085,15.691Zm2.581-7.216c.014,0,.329.347.03,1.012A.755.755,0,0,1,21.666,8.475Zm-.651,5.045a22.444,22.444,0,0,0,.842-2.381,10.776,10.776,0,0,0,1.2,1.745A15.682,15.682,0,0,0,21.016,13.52Zm4.061-.151a.474.474,0,0,1-.381.139c-.168,0-.23-.1-.487-.3a4.532,4.532,0,0,1,.57-.034c.28,0,.331.041.37.062A.489.489,0,0,1,25.077,13.369Z",
    transform: "translate(-8.166 -5.417)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.2c896169a80406aa4084d4ccd8b7c4d0.svg";
export { ForwardRef as ReactComponent };